export default __webpack_public_path__ + "static/media/focus-areas.a9e6671c.svg";